module.exports = __webpack_public_path__ + "img/v1_no3_p6.fd7cb31f.jpg";